import React from "react";
import DataTable from "./ui/DataTable";

export const MiniTable = () => {
  const features = [
    {
      text: "Like products",
      icon: "/assets/images/icons/like.svg",
    },
    {
      text: "Save products",
      icon: "/assets/images/icons/save.svg",
    },
    {
      text: "Add to algorithm",
      icon: "/assets/images/icons/add.svg",
    },
  ];

  // Columns only include image, name, brand, description as requested
  const columns = [
    {
      key: "image",
      header: "Image",
      sortable: false,
      render: (product) => (
        <img
          src={product.image}
          alt={product.name}
          style={{ width: "16px", height: "16px", objectFit: "cover", borderRadius: "8px" }}
        />
      ),
    },
    {
      key: "name",
      header: "Name",
      sortable: true,
      render: (product) => (
        <a
          href={`https://cosmelytix.com/products/${product.id}`}
          target="_blank"
          rel="noopener noreferrer"
          className="text-secondary hover:underline"
        >
          {product.name}
        </a>
      ),
    },
    
    { key: "brand", header: "Brand", sortable: true },
    { key: "description", header: "Description", sortable: false },
  ];
  

  const products = [
    {
      id: 100028,
      image: "https://cosmelytix-products-imgs.s3.us-east-1.amazonaws.com/af56120bbcf4d06-antibacterial-hydrating-essence-spray.webp",
      name: "Anti-Bacterial Hydrating Essence Spray",
      brand: "Revolution Skincare",
      description: "Containing an anti-bacterial agent and H...",
    },
    {
      id: 100036,
      image: "https://cosmelytix-products-imgs.s3.us-east-1.amazonaws.com/716f2685c4d8031-sebiaclear-spf50-cream.webp",
      name: "Sebiaclear SPF50+ Cream",
      brand: "SVR Sebiaclear",
      description: "Protects and corrects oily skin with imp...",
    },
    {
      id: 100062,
      image: "https://cosmelytix-products-imgs.s3.us-east-1.amazonaws.com/bf0142abc5092c6-illuminants-axillight-treatment-antiperspirant.webp",
      name: "Wake Up & Makeup Prep Sheet Mask",
      brand: "Skinesque",
      description: "Skin is refreshed (no tacky oily film le...",
    },
    {
      id: 100103,
      image: "https://cosmelytix-products-imgs.s3.us-east-1.amazonaws.com/227f1e9a6748c01-eye-woke-up-like-this.webp",
      name: "Illuminants+ Axillight: Treatment Antiperspirant",
      brand: "VMV HYPOALLERGENICS",
      description: "Active lightening treatment for underarm...",
    },
    {
      id: 5,
      image: "https://example.com/image5.jpg",
      name: "eye woke up like this",
      brand: "SFGlow",
      description: "tell your under eyes to just chill - you...",
    },
    {
      id: 100105,
      image: "https://cosmelytix-products-imgs.s3.us-east-1.amazonaws.com/a94fcce149705cc-collagen-serum.webp",
      name: "Collagen Serum",
      brand: "Puca Pure & Care",
      description: "Stimulates the skin’s collagen regenerat...",
    },
    {
      id: 100119,
      image: "https://cosmelytix-products-imgs.s3.us-east-1.amazonaws.com/0a584093d782f39-rescue-me-rest-reset-mask-moisturizer.webp",
      name: "Rescue Me Rest + Reset Mask & Moisturizer",
      brand: "goodhabit",
      description: "An intensely nourishing sleep mask/moist...",
    },
    {
      id: 100152,
      image: "https://cosmelytix-products-imgs.s3.us-east-1.amazonaws.com/f1f899147824168-caffeine-multi-eye-benefit-serum.webp",
      name: "Caffeine + Multi Eye Benefit Serum",
      brand: "Skin Physics",
      description: "Revitalising complex de puffs, brightens...",
    },
    {
      id: 100185,
      image: "https://cosmelytix-products-imgs.s3.us-east-1.amazonaws.com/675c196739659c4-vitamin-c-serum.webp",
      name: "Vitamin C Serum",
      brand: "artnaturals",
      description: "fights free radicals and reduces wrinkle...",
    },

    {
      id: 100211,
      image: "https://cosmelytix-products-imgs.s3.us-east-1.amazonaws.com/31eb7042131c4fc-pantalla-solar-bebes-ni%C3%B1os-y-adultos-50-spf.webp",
      name: "Pantalla Solar Bebes, Niños Y Adultos 50+ SPF",
      brand: "Simond's",
      description: "Protective screen with sun protection fa...",
    },
    {
      id: 100220,
      image: "https://cosmelytix-products-imgs.s3.us-east-1.amazonaws.com/2a60c8d25c2119a-foaming-face-wash.webp",
      name: "Foaming Face Wash",
      brand: "Perfect O",
      description: "oil free foaming face wash for oily ski...",
    },
    {
      id: 100223,
      image: "https://cosmelytix-products-imgs.s3.us-east-1.amazonaws.com/36104e4a1f47084-elixir-collection-the-ritual-of-mehr-conditioner.webp",
      name: "Elixir Collection The Ritual Of Mehr Conditioner",
      brand: "RITUALS",
      description: "Hair conditioner.",
    },
    {
      id: 100243,
      image: "https://cosmelytix-products-imgs.s3.us-east-1.amazonaws.com/1e86f01693daa63-shampoo.webp",
      name: "Shampoo",
      brand: "Sebclair",
      description: "Treatment for seborrhoeic dermatitis of ...",
    },
    {
      id: 100260,
      image: "https://cosmelytix-products-imgs.s3.us-east-1.amazonaws.com/82b04414c41688d-bring-the-light-cleanser.webp",
      name: "Bring The Light Cleanser",
      brand: "n'pure",
      description: "Facial cleanser containing 5 bright boos...",
    },
    {
      id: 100317,
      image: "https://cosmelytix-products-imgs.s3.us-east-1.amazonaws.com/306bb8c0ddffaf7-ciclopirox-shampoo.webp",
      name: "Ciclopirox Shampoo",
      brand: "Perrigo",
      description: "Anti fungal shampoo .",
    },
    {
      id: 100322,
      image: "https://cosmelytix-products-imgs.s3.us-east-1.amazonaws.com/3da8b15a4224b37-gold-hydrogel-eye-patch.webp",
      name: "Gold Hydrogel Eye Patch",
      brand: "Petitfee",
      description: "A moisturizing and firming eye mask that...",
    },
  ];

  return (
    <main className="mx-auto my-0">










      {/* Desktop Layout */}
      <div
  className="hidden lg:block"
  style={{
    transform: "scale(0.77)",
    transformOrigin: "top left",
  }}
  
>
  <div>
    <div className="relative h-[701px]">
      <div className="absolute w-full h-full">

          <div className="w-full h-[634px] top-[84px] left-0 bg-[#c58348] absolute rounded-[20px] shadow-[0px_4px_4px_#00000040]" />

          {/* DataTable without pagination or filters */}
          <div className="h-auto top-0 left-[486px] bg-[#A89B8D] absolute rounded-[20px] shadow-[0px_4px_4px_#00000040] p-8 overflow-auto"
          style={{
            left: "48%",           // position roughly center-ish
            // transform: "translateX(-48%)",  // center horizontally by shifting half width
            width: "70vw",         // 60% of viewport width (adjust as you want)
            maxWidth: "1000px",    // max width so it doesn't grow too large on huge screens
            // height: "80vh",        // 80% of viewport height, adjust as needed
            minWidth: "360px",     // minimum width for small screens
          }}
          
          >
            <DataTable
              columns={columns}
              data={products}
              pagination={false}
              filterable={false}
              sortable={true}
              // selectable={true}
              emptyMessage="No products found."
              rowClassName="hover:bg-gray-200 cursor-pointer"
            />
          </div>

      </div>

      <div className="flex flex-col w-[432px] items-center gap-12 absolute top-[166px] left-[26px]">
        
      <div className="flex flex-col items-center gap-8 px-4 md:px-0">
  {/* Header text */}
  <p className="relative px-10 max-w-md font-medium text-white text-xl md:text-2xl leading-snug tracking-wide text-center md:text-left transition-all duration-300 hover:text-purple-200">
    Explore our curated cosmetics database and add products to your skin profile to receive personalized recommendations tailored just for you.
  </p>

  {/* Feature card */}
  <div className="relative flex flex-col w-full md:w-[360px] bg-white bg-opacity-10 backdrop-blur-md rounded-2xl shadow-md p-4 transition-transform transform hover:-translate-y-1 hover:shadow-xl">
    <div className="flex flex-col gap-4">
      {features.map((feature, index) => (
        <div
          key={index}
          className="flex items-center gap-3 bg-white bg-opacity-15 backdrop-blur-sm rounded-lg px-3 py-2 transition-transform transform hover:scale-105 hover:bg-opacity-30 cursor-pointer"
        >
          <img
            src={feature.icon}
            alt="icon"
            className="w-6 h-6 md:w-7 md:h-7"
          />
          <span className="text-[#5f40a1] font-semibold text-lg md:text-xl transition-colors duration-300 group-hover:text-purple-400">
            {feature.text}
          </span>
        </div>
      ))}
    </div>
  </div>

  {/* CTA button */}
  <button className="relative w-full max-w-[300px] h-16 group">
    <div className="w-full h-full rounded-full bg-gradient-to-r from-[#5f40a1] to-[#9b59b6] flex items-center justify-center shadow-md transform transition-transform duration-300 group-hover:scale-105 group-hover:shadow-xl">
      <span className="text-white font-semibold text-xl md:text-2xl tracking-wide transition-colors duration-300 group-hover:text-yellow-200">
        View products
      </span>
    </div>
  </button>
</div>





      </div>
    </div>
  </div>
</div>







{/* Mobile Layout */}
<div className="block lg:hidden w-full p-4">
<div className="flex flex-col md:flex-row items-start md:items-center justify-between bg-gradient-to-r from-[#c58348] to-[#d69e5b] rounded-2xl p-6 shadow-lg mb-6 transition-transform transform hover:-translate-y-1 hover:shadow-2xl">
  {/* Left text */}
  <p className="text-white text-base md:text-lg font-medium flex-1 mb-4 md:mb-0 md:mr-6 leading-relaxed">
    Explore our curated cosmetics database and add products to your skin profile to receive personalized recommendations tailored just for you.
  </p>

  {/* Right icons with names */}
  <div className="flex flex-wrap md:flex-col gap-3 md:gap-4">
    {features.map((feature, index) => (
      <div key={index} className="flex items-center bg-white bg-opacity-20 backdrop-blur-sm rounded-xl px-3 py-2 text-[#5f40a1] text-sm md:text-base font-semibold transition-colors hover:bg-opacity-40">
        <img src={feature.icon} alt="icon" className="w-5 h-5 md:w-6 md:h-6 mr-2" />
        <span>{feature.text}</span>
      </div>
    ))}
  </div>
</div>


  {/* DataTable without pagination */}
  <DataTable
    columns={columns}
    data={products}
    pagination={false}
    filterable={false}
    sortable={true}
    emptyMessage="No products found."
  />

  <button
    className="w-full py-3 text-center text-white border-2 border-white rounded-full text-lg font-normal mt-6 cursor-pointer
    hover:border-secondary hover:text-secondary focus:border-secondary focus:text-secondary active:border-secondary active:text-secondary transition-colors duration-200"
  >
    View products
  </button>
</div>

    </main>
  );
};
